import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Col, Row, Input } from "../../common/UIComponents";
import I18n from "../../common/I18n";
import Button_v2 from "../../stories/components/Button_v2";

const { TextArea } = Input;

const PaperworkApprovalReasonModal = ({
  visible,
  onCancel,
  onSubmit,
  loading,
  title,
  requireNotes,
}) => {
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!visible) {
      setDescription("");
    }
  }, [visible]);

  const handleClose = () => {
    setDescription("");
    onCancel();
  };

  const handleSubmit = () => {
    if (requireNotes && !description.trim()) {
      return;
    }
    onSubmit(description.trim());
  };

  const isSubmitDisabled = loading || (requireNotes && !description.trim());

  return (
    <Modal
      title={title || "Approval Reason"}
      visible={visible}
      onCancel={handleClose}
      className="ssc-modal"
      footer={[
        <Button_v2
          key="close"
          size="medium"
          onClick={handleClose}
          className="flat small-btn"
          text={I18n.t("general.close")}
          disabled={loading}
        />,
        <Button_v2
          key="submit"
          size="medium"
          onClick={handleSubmit}
          className="small-btn raised"
          text="Submit"
          disabled={isSubmitDisabled}
        />,
      ]}
      width={440}
    >
      <div className="ssc-modal-form">
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <div className="ssc-field">
              <label className="ssc-field__label">
                Notes / Reason
                {requireNotes && <span style={{ color: "red" }}> *</span>}
              </label>
              <TextArea
                rows={3}
                placeholder={I18n.t("OrderStatus.description")}
                className="sop-form-textArea"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

PaperworkApprovalReasonModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string,
  requireNotes: PropTypes.bool,
};

PaperworkApprovalReasonModal.defaultProps = {
  loading: false,
  title: "Approval Reason",
  requireNotes: false,
};

export default PaperworkApprovalReasonModal;
